import DesktopDivider from 'omakase/FormBlock/DesktopDivider';
import MobileDivider from 'omakase/FormBlock/MobileDivider';
import React from 'react';

interface FormDividerProps {
  mobileOnly: boolean;
}

const FormDivider: React.FunctionComponent<FormDividerProps> = ({ mobileOnly }) => (
  <div>
    <MobileDivider />
    {!mobileOnly && <DesktopDivider />}
  </div>
);

export default FormDivider;
